export default __webpack_public_path__ + "static/media/single-project-page-05-img-07.63f9186f.png";